module.exports = __webpack_public_path__ + "img/773b116.svg";